import React from 'react'

// Components
import Blog from 'components/flex/Posts/Blog'
import Professionals from 'components/flex/Posts/Professionals'
import Stories from 'components/flex/Posts/Stories'
import Members from 'components/flex/Posts/Members'
import Inquiries from 'components/flex/Posts/Inquiries'

interface PostsShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location?: any
}

interface PostProps {
  [key: string]: any
}

const PostsShell: React.FC<PostsShellProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    blog: Blog,
    professionals: Professionals,
    stories: Stories,
    members: Members,
    inquiries: Inquiries,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default PostsShell
